<app-feature-editor title="Particle Trace Groups" [getItems]="getParticleTraces" [addItem]="addParticleTrace" [deleteItem]="deleteParticleTrace"
                (selectedIdChange)="particleTraceIdChanged($event)">
  <div *ngIf="hasParticleTrace">
    <app-groupbox header="Results" headerClass="pane-bg-color">
      <div class="table">
        <div class="row">
          <div class="label-cell">Compute vector</div>
          <div class="control-cell">
            <select #vectorResultSelect [value]="vectorResultId" (change)="vectorResultIdChanged(vectorResultSelect.value)">
                <option *ngFor="let item of vectorResults" [value]="item.id">{{item.name}}</option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="label-cell">Map scalar</div>
          <div class="control-cell">
            <select #mapScalarResultSelect [value]="mapScalarResultId" (change)="mapScalarResultIdChanged(mapScalarResultSelect.value)">
                <option *ngFor="let item of scalarResultsWithNone" [value]="item.id">{{item.name}}</option>
              </select>
          </div>
        </div>
      </div>
    </app-groupbox>
    <div class="spacer"></div>
    <app-groupbox header="Style" headerClass="pane-bg-color">
      <div class="table">
        <div class="row">
          <div class="label-cell">Shape</div>
          <div class="control-cell">
            <select #visualizationStyleSelect [value]="visualizationStyle" (change)="visualizationStyleChanged(visualizationStyleSelect.value)">
              <option *ngFor="let item of visualizationStyles" [value]="item.id">{{item.name}}</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="label-cell">Color</div>
          <div class="control-cell">
            <app-color-picker #colorPicker [value]="color" (change)="colorChanged(colorPicker.value)"></app-color-picker>
          </div>
        </div>
        <div class="row">
          <div class="label-cell">Radius</div>
          <div class="control-cell">
            <app-slider-textbox #radiusControl [value]="radius" [min]="0.00001" [max]="0.0001" [precision]="6" (change)="radiusChanged(radiusControl.value)"></app-slider-textbox>
          </div>
        </div>
        <div *ngIf="isSpheres || isComets" class="row">
          <div class="label-cell">Num pulses</div>
          <div class="control-cell">
            <app-slider-textbox #pulseCountControl [value]="pulseCount" [min]="5" [max]="200" [integer]="true" (change)="pulseCountChanged(pulseCountControl.value)"></app-slider-textbox>
          </div>
        </div>
        <div *ngIf="isComets" class="row">
          <div class="label-cell">Relative comet length</div>
          <div class="control-cell">
            <app-slider-textbox #relCometLengthControl [value]="relativeCometLength" [min]="0.00001" [max]="0.1" [precision]="6" (change)="relativeCometLengthChanged(relCometLengthControl.value)"></app-slider-textbox>
          </div>
        </div>
        <div class="row">
          <div class="label-cell">Trace both directions</div>
          <div class="control-cell"><input #traceBothDirsCheckbox type="checkbox" [checked]="traceBothDirections" (change)="traceBothDirectionsChanged(traceBothDirsCheckbox.checked)" /></div>
        </div>
      </div>
    </app-groupbox>
    <div class="spacer"></div>
    <app-groupbox header="Seed points" headerClass="pane-bg-color">
      <div class="table">
        <div class="row">
          <div class="label-cell">Num U</div>
          <div class="control-cell">
            <app-slider-textbox #numUControl [value]="numU" [min]="1" [max]="100" [integer]="true" (change)="numUChanged(numUControl.value)"></app-slider-textbox>
          </div>
        </div>
        <div class="row">
          <div class="label-cell">Num V</div>
          <div class="control-cell">
            <app-slider-textbox #numVControl [value]="numV" [min]="1" [max]="100" [integer]="true" (change)="numVChanged(numVControl.value)"></app-slider-textbox>
          </div>
        </div>
        <div class="row">
          <div class="label-cell">Spacing</div>
          <div class="control-cell">
            <app-slider-textbox #spacingControl [value]="spacing" [min]="0.00003" [max]="0.003" [precision]="6" (change)="spacingChanged(spacingControl.value)"></app-slider-textbox>
          </div>
        </div>
      </div>
      <div class="buttons-container">
        <button [class]="pickButtonClass" (click)="togglePick()">Pick</button>
      </div>
    </app-groupbox>
  </div>
</app-feature-editor>
